import { render, staticRenderFns } from "./salesAgents.vue?vue&type=template&id=450cb7ee&scoped=true"
import script from "./salesAgents.vue?vue&type=script&lang=js"
export * from "./salesAgents.vue?vue&type=script&lang=js"
import style0 from "./salesAgents.vue?vue&type=style&index=0&id=450cb7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450cb7ee",
  null
  
)

export default component.exports